import { isIos, appVersion } from 'util/global';
import { onLoad } from 'util/onload';

import 'lib/ajax_upload';

import 'util/ajax';
import 'util/autosubmit';
import 'util/deferred';
import 'util/vkey';
import 'util/pager';
import 'util/popstate';
import 'util/sharing';

import 'app/generic_controllers';
import 'app/header';
import 'app/paid';
import 'app/front_chat';
import 'app/notifications';
import 'app/content_modal';
import 'app/comments';
import 'app/discussions';
import 'app/solvables';
import 'app/disputes';
import 'app/solution_discussions';
import 'app/instant_response';
import 'app/newsfeed';
import 'app/error_modal';
import 'app/preloaders';
import 'app/nux';
import 'app/visualizations';
import 'app/videos';
import 'app/zoomable';
import 'app/signup';
import 'app/codex/controllers';
import 'app/surveys';

// let iOS native code know we're done loading
if (isIos && appVersion.isGreaterThanOrEqualTo('0.9.1')) {
    const loadingComplete = () => {
        window.location = 'loadcomplete://';
    };

    if (window.isLoaded) {
        loadingComplete();
    } else {
        onLoad(loadingComplete);
    }
}
